import Vue from 'vue';
// @ts-expect-error: No type definitions :(
import moment from 'vue-moment';

Vue.use(moment);
